import { yup } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"

export const validationSchema = (t) => yup.object({
    password: yup
        .string()
        .required(t(I18N_NAMESPACE, "forms.loginForm.fields.password.requireMessage")),
})